import { render, staticRenderFns } from "./YoungChat.vue?vue&type=template&id=82b14ba6&scoped=true&"
import script from "./YoungChat.vue?vue&type=script&lang=js&"
export * from "./YoungChat.vue?vue&type=script&lang=js&"
import style0 from "./YoungChat.vue?vue&type=style&index=0&id=82b14ba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b14ba6",
  null
  
)

export default component.exports